// libs
import React, { useState, useEffect, memo } from 'react';

// global components
import ResponsiveLoader from 'shared/components/ResponsiveLoader';

// components
import WidgetCarousel from 'shared/layouts/DetailsPage/components/Widgets/components/WidgetCarousel';
import MobileCarousel from 'shared/layouts/DetailsPage/components/Widgets/components/MobileCarousel';
import ViewAllButton from 'shared/layouts/DetailsPage/components/Widgets/components/ViewAllButton';

// helpers
import { getSettings } from './helpers';

// styles
import { WidgetContainer, WidgetHeaderwithoutBorder, WidgetWrapperSection } from './styles';

// constants
import { DEFAULT_SETTING, WIDGET_MOBILE } from './constants';

// defs
import { IWidgetData } from 'shared/layouts/DetailsPage/components/Widgets/types';

function RenderSmartCarousel({ widget, isCAV = false }: { widget: IWidgetData; isCAV?: boolean }) {
  const [settingObj, setSettingObj] = useState(DEFAULT_SETTING);

  useEffect(() => {
    const onResize = () => {
      const newSettings = getSettings();
      setSettingObj(newSettings);
    };

    window.addEventListener('resize', onResize, false);
    onResize();

    return () => window.removeEventListener('resize', onResize, false);
  }, []);

  const { widgetContainerStyle } = settingObj;

  const products = widget.products ? widget.products : widget.categories;
  const widgetMetadata = {
    widgetTitle: widget.title,
    widgetType: widget.widget_type,
    widgetPosition: widget?.position + 1,
    widgetIdentifier: widget?.widget_type,
  };

  return (
    <div className="widgetComponent" style={widgetContainerStyle}>
      <ResponsiveLoader breakpoint={1024} up>
        <WidgetCarousel
          products={products}
          action_url={widget.action_url}
          isCAV={isCAV}
          widgetMetadata={widgetMetadata}
        />
      </ResponsiveLoader>
      <ResponsiveLoader breakpoint={1023} down>
        <MobileCarousel products={products} isCAV={isCAV} widgetMetadata={widgetMetadata} />
      </ResponsiveLoader>
    </div>
  );
}

interface IRenderBasicSliderProps {
  widget: IWidgetData;
  i: number;
  isDesktop: boolean;
  isSimilarProductsOnTop?: boolean;
  showTopBorder?: boolean;
}

function RenderBasicSlider({
  widget,
  i,
  isDesktop,
  isSimilarProductsOnTop,
  showTopBorder = false,
}: IRenderBasicSliderProps) {
  const settingObj = isDesktop ? DEFAULT_SETTING : WIDGET_MOBILE;
  const { widgetContainerStyle } = settingObj;
  // not showing top black border for similar products widgets
  const shouldShowViewAll = !isDesktop && widget.show_view_all;

  return (
    <WidgetWrapperSection
      key={i}
      hasPadding={!isSimilarProductsOnTop}
      id={`widget_${i}`}
      className="widget-section"
      showTopBorder={showTopBorder}
    >
      <WidgetHeaderwithoutBorder data-test="widget-testing" className="widgetTitle">
        {widget.title}
        {shouldShowViewAll && <ViewAllButton widget={widget} />}
      </WidgetHeaderwithoutBorder>
      <WidgetContainer className="widgetComponent" style={widgetContainerStyle}>
        <RenderSmartCarousel widget={widget} />
      </WidgetContainer>
    </WidgetWrapperSection>
  );
}

export default memo(RenderBasicSlider);
